module.exports = "/_next/static/images/eb6d0f9502bea47a0a496a89beb65b89-card-and-phone-3d-lg@2x.jpg.webp";